import { NavigationContainerRefWithCurrent } from '@react-navigation/native';
import { useBottomSheet } from 'context/BottomSheetContext';
import * as WebBrowser from 'expo-web-browser';
import { useRef } from 'react';
import { Linking, Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { WebView } from 'react-native-webview';

import { BottomSheet } from '../BottomSheet/BottomSheet';
import LiveMenuButton from './LiveMenuButton';

import { Icons } from 'components/Icons';

export const LiveSheet: React.FC<{ navigationRef?: NavigationContainerRefWithCurrent<any> }> = ({
  navigationRef,
}) => {
  const { currentMenu, handleToggleSheet, currentUrl, visible, liveMenuItems } = useBottomSheet();
  const webViewRef = useRef<WebView>(null);

  const handleWebBrowser = async (url: string) => {
    await WebBrowser.openBrowserAsync(url);
  };

  const countAndAddSlash = (input: string): string => {
    let count = 0;
    for (let char of input) {
      if (char === '/') {
        count++;
      }
    }
    if (count < 3) {
      input += '/';
    }
    return input;
  };

  const handleNavigationStateChange = (navState: any) => {
    if (navState.url.includes('https://login')) {
      handleToggleSheet();
      Linking.openURL(navState.url);
      return;
    }

    if (navState.url !== countAndAddSlash(currentUrl) && !navState.loading) {
      webViewRef?.current?.stopLoading?.();
      handleWebBrowser(navState.url);
      webViewRef?.current?.goBack();
    }
  };

  const handleComponent = () => {
    return (
      <View style={styles.headerContainer}>
        <View style={styles.handleBar} />

        <View style={styles.headerContent}>
          <View style={styles.titleContainer}>
            <LiveMenuButton disabled>
              <Text style={styles.menuTitle}>{currentMenu?.name}</Text>
              {!!liveMenuItems.length && <Icons.ChevronDown color={'#555555'} />}
            </LiveMenuButton>
          </View>
          <Pressable onPress={() => handleToggleSheet()}>
            <Icons.Xmark color={'#555555'} />
          </Pressable>
        </View>
      </View>
    );
  };

  if (!visible) {
    return <></>;
  }

  return (
    <BottomSheet navigationRef={navigationRef}>
      <View style={styles.container}>
        {handleComponent()}
        {Platform.OS === 'web' ? (
          <iframe src={currentUrl} style={{ flex: 1 }} />
        ) : (
          <WebView
            ref={webViewRef}
            nestedScrollEnabled
            onNavigationStateChange={handleNavigationStateChange}
            startInLoadingState={true}
            source={{ uri: currentUrl }}
            style={{ flex: 1 }}
          />
        )}
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  headerContainer: {
    height: 60,
    backgroundColor: '#F5F7FA',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomColor: '#D1D2D7',
    borderBottomWidth: 1,
  },
  handleBar: {
    height: 5,
    width: 40,
    borderRadius: 5,
    backgroundColor: '#070D314D',
    alignSelf: 'center',
  },
  headerContent: {
    paddingHorizontal: 20,
    flexDirection: 'row',
    paddingTop: 12,
  },
  titleContainer: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },
  menuTitle: {
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 24,
    marginRight: 15,
  },
});
